<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                        Self Appraisal Report
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <v-row class="sub-row" justify="center" dense>
                <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                    <p class="padding-bot"><b>Academic Year</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="academicyear" :items="aylist" item-text="ay" item-value="id" label="Academic Year" outlined />
                </v-col>
                <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                    <p class="padding-bot"><b>Instructor List</b></p>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="instructor" return-object :items="instructor_list" item-text="name" item-value="id" label="Instructor" outlined />
                </v-col>
                <v-col cols="12" xs="12" sm="2" lg="2" md="12">
                    <p class="padding-bot"><b></b></p>
                    <br />
                    <v-btn class="toolbar" outlined dense rounded :loading="loader" @click="fetchSelfAppriasalData"> Fetch</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-card class="box" v-if="this.show_table == true">
            <v-toolbar class="toolbar" flat dense>
                <v-toolbar-title>
                    <strong>
                       Self Appraisal Report
                    </strong>
                </v-toolbar-title>
            </v-toolbar>
            <br />
            <v-simple-table class="elevation-1" v-if="headers_list_size!=''">
                <template>
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Name</th>
                            <th :colspan="headers_list_size" v-for="(item,index) in sub_parameters_list" :key="index">
                               <b>{{item}}</b>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th></th>
                            <th></th>
                            <th v-for="(item1,index) in headers_list" :key="index">
                                {{item1}}
                            </th>
                        </tr>
                        <tr v-for="(item,index) in instructor_list_new" :key="index">
                            <td>{{index+1}}</td>
                            <td><b>{{item.name}}</b></td>
                            <td v-for="(a,index1) in item.all_marks" :key="index1">
                                {{a}}
                            </td>
                            <td v-for="(a,index1) in item.total_marks" :key="index1">
                                {{a}}
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-card>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            loader: false,
            proceed_loader: false,
            search: "",
            snackbar_msg: "",
            snackbar: false,
            color: "",
            aylist: [],
            instructor_list: [],
            instructor: "",
            academicyear: "",
            basepath: "",
            selfAuthoritymarks: [],
            all_data_list: [],
            show_table: false,
            sub_parameters_list: [],
            headers_list: [],
            instructor_list_new: [],
            headers_list_size: "",
            headers_weight_list:[],
        }),
        methods: {
            fetchSelfAppriasalData() {
                this.loader = true;
                const formData = {
                    ay: this.academicyear,
                    instructor: this.instructor.id,
                };
                axios
                    .post("/FillSelfAppriasal/fetchSelfAppriasalReport", formData)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.loader = false;
                            //  this.all_data_list=res.data.final_list[0]
                            this.instructor_list_new = res.data.instructor_list;
                            this.sub_parameters_list = res.data.sub_parameters_list;
                            this.headers_list = res.data.headers_list;
                            this.headers_list_size = res.data.headers_list_size;
                            this.show_table = true;
                        } else {
                            this.loader = false;
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },

            onLoad() {
                axios
                    .post("/FillSelfAppriasal/getData")
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.aylist = res.data.aylist;
                            this.basepath = res.data.aws_path;
                            this.instructor_list = res.data.instructor_list_approving;
                            this.academicyear = res.data.cay;
                        } else {
                            //   window.console.log(res.data.msg);
                            this.showSnackbar("#b71c1c", "Something went wrong!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
        },
        mounted() {
            this.onLoad();
        },
    };
</script>

<style scoped>
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
</style>
